import { type FunctionalComponent, h } from '@stencil/core';
import { clearStore } from '../../checkbox/uiaas-checkbox-helpers';
import { barClear } from '../uiaas-compare-bar-labels';
import type { labelProviderInterface } from '../../../LabelProviderInterface';

interface ICompareCleanPartial {
  labelProvider: labelProviderInterface;
  storageKey: string;
  isMobile: boolean;
  isProductRelatedTab: boolean;
}

export const CompareCleanPartial = (
  props,
): FunctionalComponent<ICompareCleanPartial> => (
  <div class="compare-wrapper-bar-clean">
    {props.isMobile || !props.isProductRelatedTab ? (
      <qds-icon
        name="trash-can"
        library="default"
        class="compare-wrapper-bar-clean__icon"
        tabindex={0}
        data-compare-area={'clear_list'}
        onClick={(e) => {
            clearStore(props.storageKey);
            e.preventDefault();
        }}
        onKeyDown={(e) =>
          e.key === 'Enter' ? clearStore(props.storageKey) : void 0
        }
      ></qds-icon>
    ) : (
      <qds-standalone-link
        icon-name="trash-can"
        icon-library="default"
        importance="subdued"
        data-compare-area={'clear_list'}
        onClick={(e) => {
            clearStore(props.storageKey);
            e.preventDefault();
        }}
        onKeyDown={(e) =>
          e.key === 'Enter' ? clearStore(props.storageKey) : void 0
        }
      >
        {props.labelProvider(barClear.label, barClear.fallback)}
      </qds-standalone-link>
    )}
  </div>
);
